import { TextField, type TextFieldProps } from "@mui/material";
import { forwardRef } from "react";

import {
  ClearSearchButton,
  useClearSearch
} from "@/components/sitehub-ui/atoms/ClearSearchButton";

export type SearchTextFieldProps = TextFieldProps & {
  onClearSearch?: () => void;
};

const SearchTextField = forwardRef<HTMLDivElement, SearchTextFieldProps>(
  function SearchTextField({ onClearSearch, ...props }, ref) {
    const search = useClearSearch({
      value: props.value ?? props.InputProps?.value,
      defaultValue: props.defaultValue,
      inputRef: props.inputRef,
      onClear: onClearSearch
    });
    const readOnly = props.InputProps?.readOnly || props.inputProps?.readOnly;
    return (
      <TextField
        {...props}
        ref={ref}
        inputRef={search.inputRef}
        inputProps={{
          ...props.inputProps,
          onInput: (event) => {
            search.capture(event);
            props.inputProps?.onInput?.(event);
          }
        }}
        InputProps={{
          ...props.InputProps,
          endAdornment: (
            <>
              {search.text.length > 0 &&
              !props.disabled &&
              !props.InputProps?.disabled &&
              !props.inputProps?.disabled &&
              !readOnly ? (
                <ClearSearchButton onClear={search.clear} />
              ) : null}
              {props.InputProps?.endAdornment}
            </>
          )
        }}
        sx={[
          {
            "& input[type=search]::-webkit-search-cancel-button": {
              WebkitAppearance: "none"
            }
          },
          ...(Array.isArray(props.sx) ? props.sx : [props.sx ?? {}])
        ]}
      />
    );
  }
);

export default SearchTextField;
